import { DarkTooltip } from 'components/Tooltips/CustomTooltips';
import HelpIcon from '@mui/icons-material/Help';
import { colors } from 'utilities';
import styles from './styles.module.scss';
import { useTranslates } from 'providers/translates';



export const StatusText: React.FC = () => {
  const { translates: t } = useTranslates(); 
  const myQuilts = t?.myQuilts;
//   <Box sx={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
//   <span className="defaultTitle1">{e}</span>
//   <DarkTooltip title={'Quilt owners can change the status.'}>
//     <HelpIcon sx={{ color: colors.blue }} />
//   </DarkTooltip>
// </Box>
  
  return (
    <div className={styles.statusText}>
      <p>
        {myQuilts?.myQuiltsStatusHeading ?? 'Status'}
      </p>
      <DarkTooltip
        title={
          <span>
            {myQuilts?.myQuiltsStatusTooltip ?? 'info text'}
          </span>
        }
      >
        <HelpIcon sx={{ width: '20px', color: colors.blue }} />
      </DarkTooltip>
    </div>
  );
}
